const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export type RelativeTimeKey = "justNow" | "minutesAgo" | "hoursAgo" | "daysAgo";

/**
 * Bucket for a feed row's relative time ("just now", "11 min ago", "3 h ago", "2 d ago"); the
 * caller translates the key with `count`. Pure — `now` is a parameter, so the ticking lives in
 * whichever component renders the row. Shared by every latest-wins feed (Sprint Missions,
 * jackpots), which is why it lives here and not in one module's `types.ts`.
 */
export function relativeTimeParts(
  wonAt: string,
  now: number = Date.now()
): { key: RelativeTimeKey; count: number } {
  const at = Date.parse(wonAt);
  const ms = Number.isFinite(at) ? Math.max(0, now - at) : 0;
  if (ms < MINUTE_MS) return { key: "justNow", count: 0 };
  if (ms < HOUR_MS)
    return { key: "minutesAgo", count: Math.floor(ms / MINUTE_MS) };
  if (ms < DAY_MS) return { key: "hoursAgo", count: Math.floor(ms / HOUR_MS) };
  return { key: "daysAgo", count: Math.floor(ms / DAY_MS) };
}
